/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export interface FilterMeta {
  title: string;
  operator: string;
  value?: string;
  operatorOnly?: boolean;
}

export enum Filter {
  Contains = 'contains',
  DoesNotContain = 'doesNotContain',
  Equals = 'equals',
  IsNotEqual = 'isNotEqual',

  // TODO:
  //Is = 'is',
  IsEmpty = 'isEmpty',
  IsNotEmpty = 'isNotEmpty',

  LessThan = 'lessThan',
  GreaterThan = 'greaterThan',
  LessThanOrEquals = 'lessThanOrEquals',
  GreaterThanOrEquals = 'greaterThanOrEquals',

  HasMappedObjects = 'HasMappedObjects',
  DoesNotHaveMappedObjects = 'DoesNotHaveMappedObjects',
}

export const filtersMeta: { [key in Filter]: FilterMeta } = {
  [Filter.Contains]: { operator: '~', title: 'Contains' },
  [Filter.DoesNotContain]: { operator: '!~', title: 'Does not contain' },
  [Filter.Equals]: { operator: '=', title: 'Equals' },
  [Filter.IsNotEqual]: { operator: '!=', title: 'Does not equal' },

  // TODO:
  // [Filter.Is]: { operator: 'IS', title: 'Is' },
  [Filter.IsEmpty]: { operator: 'IS_EMPTY', value: 'EMPTY', title: 'Is empty' },
  [Filter.IsNotEmpty]: { operator: 'IS_NOT_EMPTY', value: 'NOT_EMPTY', title: 'Is not empty' },

  [Filter.LessThan]: { operator: '<', title: 'Is less than' },
  [Filter.GreaterThan]: { operator: '>', title: 'Is greater than' },
  [Filter.LessThanOrEquals]: { operator: '<=', title: 'Is less than or equals' },
  [Filter.GreaterThanOrEquals]: { operator: '>=', title: 'Is more than or equals' },

  [Filter.HasMappedObjects]: { operator: 'MAPPED', title: 'Has mapped objects', operatorOnly: true },
  [Filter.DoesNotHaveMappedObjects]: {
    operator: 'NO_MAPPED',
    title: 'Does not have mapped objects',
    operatorOnly: true,
  },
};

export const dateFiltersMeta: { [key in Filter]: FilterMeta } = {
  [Filter.Equals]: { operator: '=', title: 'Is on' },
  [Filter.LessThan]: { operator: '<', title: 'Is before' },
  [Filter.GreaterThan]: { operator: '>', title: 'Is after' },
  [Filter.LessThanOrEquals]: { operator: '<=', title: 'Is before or on' },
  [Filter.GreaterThanOrEquals]: { operator: '>=', title: 'Is after or on' },
};
